import memoize from 'transmute/memoize';
import { getProperty } from '../objectAccessors';
import { fromEmptyStringToNull, toNumberOrNull } from 'products-ui-components/utils/toNumber';
import { getPriceProperty } from 'products-ui-components/utils/properties/integrations';
import { NAME, CREATE_DATE, DESCRIPTION, DISCOUNT, DISCOUNT_PERCENTAGE, QUANTITY, RECURRING_BILLING_FREQUENCY, SKU, START_DATE, TERM, PRICE, UNIT_COST, LINE_ITEM_CURRENCY_CODE, ORDER, PRODUCT_ID } from 'customer-data-objects/lineItem/PropertyNames';
import { getSubject } from '../subject';
const propertyGetters = {
  [NAME]: lineItem => getProperty(lineItem, NAME),
  [CREATE_DATE]: lineItem => getProperty(lineItem, CREATE_DATE),
  [DESCRIPTION]: lineItem => getProperty(lineItem, DESCRIPTION),
  [QUANTITY]: lineItem => toNumberOrNull(getProperty(lineItem, QUANTITY)),
  [PRICE]: lineItem => toNumberOrNull(getProperty(lineItem, getPriceProperty(lineItem))),
  [DISCOUNT]: lineItem => toNumberOrNull(fromEmptyStringToNull(getProperty(lineItem, DISCOUNT))),
  [DISCOUNT_PERCENTAGE]: lineItem => toNumberOrNull(fromEmptyStringToNull(getProperty(lineItem, DISCOUNT_PERCENTAGE))),
  [UNIT_COST]: lineItem => toNumberOrNull(getProperty(lineItem, UNIT_COST)),
  [PRODUCT_ID]: lineItem => getProperty(lineItem, PRODUCT_ID),
  // recurringbillingfrequency is a dependency for hs_recurring_billing_terms calculation
  [RECURRING_BILLING_FREQUENCY]: lineItem => getProperty(lineItem, RECURRING_BILLING_FREQUENCY) || '',
  [SKU]: lineItem => getProperty(lineItem, SKU),
  // hs_recurring_billing_period is a dependency for hs_recurring_billing_terms calculation
  [TERM]: lineItem => getProperty(lineItem, TERM) || '',
  [START_DATE]: lineItem => toNumberOrNull(getProperty(lineItem, START_DATE)),
  [LINE_ITEM_CURRENCY_CODE]: lineItem => getProperty(lineItem, LINE_ITEM_CURRENCY_CODE),
  [ORDER]: lineItem => toNumberOrNull(getProperty(lineItem, ORDER)),
  hs_tax_rate: lineItem => toNumberOrNull(getProperty(lineItem, 'hs_tax_rate')),
  hs_recurring_billing_terms: lineItem => getProperty(lineItem, 'hs_recurring_billing_terms')
};
const propertyShortcuts = {
  [NAME]: 'name',
  [CREATE_DATE]: 'createDate',
  [DESCRIPTION]: 'description',
  [QUANTITY]: 'quantity',
  [PRICE]: 'price',
  [DISCOUNT]: 'discount',
  [DISCOUNT_PERCENTAGE]: 'discountPercentage',
  [UNIT_COST]: 'unitCost',
  [PRODUCT_ID]: 'productId',
  [RECURRING_BILLING_FREQUENCY]: 'recurringBillingFrequency',
  [SKU]: 'sku',
  [TERM]: 'term',
  [START_DATE]: 'startDate',
  [LINE_ITEM_CURRENCY_CODE]: 'lineItemCurrencyCode',
  [ORDER]: 'order',
  hs_tax_rate: 'taxRate',
  hs_recurring_billing_terms: 'recurringBillingTerms'
};
const allProperties = Object.keys(propertyShortcuts);
function getLineItemProperties(lineItem, ...properties) {
  if (properties.length === 0) {
    properties = allProperties;
  }
  const subject = getSubject(lineItem);
  if (properties.length === 1) {
    if (propertyGetters[properties[0]]) {
      return propertyGetters[properties[0]](subject);
    }
    return getProperty(subject, properties[0]);
  }
  return properties.reduce((acc, property) => {
    if (propertyGetters[property]) {
      acc[propertyShortcuts[property]] = propertyGetters[property](subject);
    } else {
      acc[property] = getProperty(subject, property);
    }
    return acc;
  }, {});
}
export default memoize(getLineItemProperties);